import { loadStripe } from '@stripe/stripe-js';

// Publishable key is environment-driven like beUrl/filesUrl in Constants.ts (CRA reads
// REACT_APP_* at build time). Set REACT_APP_STRIPE_PK in an .env file to override — it
// must match the backend's Stripe:SK mode (both test or both live) or PaymentElement fails to load.
export const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PK ?? 'pk_test_51NwowlL4d2RQfnnos1H26PyYZa1ses63IwYRJqt5ZJ6TIx1DPS8sl5HNSPB1873CZnHWGundxxaAhRw1moKr0UhX00XNUQXDbr');
